import { useEffect, useState, useCallback } from 'react';
import { SessionStorage } from '@lean-body/src/infra';
export const DEFAULT_DURATION_SECONDS = 600; // 10分
/**
 * キャンペーンカウントダウンタイマーのカスタムフック
 * @param durationSeconds カウントダウンの秒数（デフォルト: 600秒 = 10分）
 * @param enabled カウントダウンを有効にするかどうか
 * @returns remainingSeconds, isExpired, formattedMinutes, formattedSeconds
 */
export const useCampaignCountdown = (durationSeconds = DEFAULT_DURATION_SECONDS, enabled = true) => {
    const [remainingSeconds, setRemainingSeconds] = useState(durationSeconds);
    const [isExpired, setIsExpired] = useState(false);
    const formatTime = useCallback((totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return {
            minutes: minutes.toString().padStart(2, '0'),
            seconds: seconds.toString().padStart(2, '0'),
        };
    }, []);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const sessionStorage = new SessionStorage();
        const now = Date.now();
        // セッションストレージから開始時刻を取得、なければ現在時刻を保存
        let startTime = sessionStorage.loadCampaignCountdownStartTime();
        if (startTime === null) {
            startTime = now;
            sessionStorage.setCampaignCountdownStartTime(startTime);
        }
        // 残り秒数を計算
        const elapsedMs = now - startTime;
        const elapsedSeconds = Math.floor(elapsedMs / 1000);
        const initialRemaining = Math.max(0, durationSeconds - elapsedSeconds);
        if (initialRemaining <= 0) {
            setRemainingSeconds(0);
            setIsExpired(true);
            return;
        }
        setRemainingSeconds(initialRemaining);
        const intervalId = setInterval(() => {
            setRemainingSeconds((prev) => {
                if (prev <= 1) {
                    clearInterval(intervalId);
                    setIsExpired(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, [enabled, durationSeconds]);
    const { minutes, seconds } = formatTime(remainingSeconds);
    return {
        remainingSeconds,
        isExpired,
        formattedMinutes: minutes,
        formattedSeconds: seconds,
    };
};
